<script>
    import { TOKEN_SESSION, USER, TOAST_MESSAGE } from "../../stores";
    import { createEventDispatcher } from "svelte";
    import { onMount } from "svelte";
    import Bars from "../Charts/Bars.svelte";
    import Pie from "../Charts/Pie.svelte";
    import GLOBALS from "../../globals/GLOBALS";

    const dispatch = createEventDispatcher();

    export let report = null;
    export let opacity = 0;
    let parametros;
    let datos = [];
    let labels = [];
    let titleData = [];
    let loadGraph = false
    let favState

    onMount(() => {
        parametros = JSON.parse(report.rep_parametros);
        favState = report.fav_parametros === "" ? false : true
        _execReport()
    })

    const _execReport = () => {
        let params = []
        parametros.forEach(element => {
            params.push(element.default)
        });
        loadGraph = false
        _REP_QUERY("EXECREPORT",{ rep_pk:report.rep_pk, params })
    }

    const _saveFavorite = () => {
        let params = []
        parametros.forEach(element => {
            params.push(element.default)
        });
        _REP_QUERY(favState ? "DELETEFAVORITE" : "SAVEFAVORITE",{ rep_usu_id : $USER.usu_id, rep_pk:report.rep_pk, params })
    }

    const _REP_QUERY = async (QUERY, data) => {
        const URL = GLOBALS.URL;
        const bearer = "Bearer " + $TOKEN_SESSION;
        await fetch(`${URL}/API/reportes/QUERY/${QUERY}`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                Authorization: bearer,
                "Content-type": "application/json;charset=UTF-8",
            },
        })
            // Handle success
            .then((response) => response.json()) // convert to json
            .then((json) => {
                if (json.result === "success") {
                    switch (QUERY) {
                        case "EXECREPORT":
                            loadGraph = false
                            labels = []
                            datos = []
                            // construye el dataset para el grafico: Es un array para mostrar mas de 1 en Bars
                            json.rows.forEach((item, index) => {
                                labels.push(item.name)
                                json.fields.filter(e => e.name !== "name").forEach( (field,idx) => {
                                    if (index === 0) datos.push(new Array())
                                    datos[idx].push(item[field.name])
                                    titleData.push(field.name)
                                })
                            })
                            loadGraph = true
                        break;
                        case "SAVEFAVORITE":
                            favState = true
                            TOAST_MESSAGE.set(json);
                        break;
                        case "DELETEFAVORITE":
                            favState = false
                            TOAST_MESSAGE.set(json);
                        break;
                    }
                } else {
                    TOAST_MESSAGE.set(json);
                    if (json.status === 403) TOKEN_SESSION.set(null)
                }
            }) //print data to console
            .catch((err) => console.log("Request Failed", err)); // Catch errors
    };

    const _close = () => {
        dispatch("close");
    }
</script>

<div class="container-fluid" style="opacity:{opacity}">
    <div class="d-flex direction-row justify-content-end mt-3">
        <div
            class="circular d-flex justify-content-center align-items-center"
            on:click={() => _close()}
        >
            <ion-icon name="close-outline" />
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12 col-md-3 ">
            {#if report}
                <h2>{report.rep_descripcion}</h2>
                {#if parametros}
                    <p>Puedes consultar el reporte actual especificando los valores de los parámetros siguientes:</p>
                    {#each parametros as param, i}
                        {#if param.type === "texto"}
                            <form class="form-floating" on:submit|preventDefault={() => console.log(null)}>
                                <input
                                    type="number"
                                    class="form-control mb-2"
                                    id="floatingInputValue"
                                    placeholder={param.name}
                                    bind:value={param.default}
                                />
                                <label for="floatingInputValue">{param.name}</label
                                >
                            </form>
                        {:else if param.type === "fecha"}
                            <!-- else if content here -->
                        {:else}
                            <!-- else content here -->
                        {/if}
                    {/each}
                {/if}
                <div class="d-flex justify-content-center align-items-center mt-4" >
                    <div class="d-flex flex-column justify-content-center align-items-center px-3">
                        <div
                            class="circular d-flex justify-content-center align-items-center s-3"
                            on:click={() => _execReport()}
                        >
                            <ion-icon name="play"></ion-icon>
                        </div>
                        <div><small>Consultar</small> </div>
                    </div>
                    <div class="d-flex flex-column justify-content-center align-items-center px-3">
                        <div
                            class="circular d-flex justify-content-center align-items-center s-3"
                            on:click={() => _saveFavorite()}
                            class:fav={favState}
                        >
                            <ion-icon name="star"></ion-icon>
                        </div>
                        <div><small>Favorito</small> </div>
                    </div>
                    <div class="d-flex flex-column justify-content-center align-items-center px-3">
                        <div
                            class="circular d-flex justify-content-center align-items-center s-3"
                            on:click={() => _close()}
                        >
                            <ion-icon name="arrow-back-sharp"></ion-icon>
                        </div>
                        <div><small>Regresar</small> </div>
                    </div>
                </div>
            {/if}
        </div>
        <div class="col-sm-12 col-md-9">
            {#if loadGraph}
                {#if report.rep_graph === "Bar"}
                     <!-- content here -->
                     <Bars
                        title={report.rep_descripcion}
                        data={datos}
                        labels={labels}
                        titleData={titleData}
                     />
                {:else if report.rep_graph === "Pie"}
                     <!-- else content here -->
                     <Pie
                        title={report.rep_descripcion}
                        data={datos[0]}
                        labels={labels}
                        titleData={titleData}
                     />
                {/if}
            {/if}
        </div>
    </div>
</div>

<style>
    .circular {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background-color: #2c3e50;
        color: #fff;
        cursor: pointer;
        transition: all 250ms;
    }

    .circular:hover {
        transform: scale(1.2);
    }

    .s-3 {
        height: 50px;
        width: 50px;
        font-size: 1.5em;
    }

    input {
        border: none;
        border-radius: unset;
        border-bottom: 1px solid #2c3e5088;
        outline: none !important;
    }

    input:focus {
        outline: none !important;
    }

    p {
        color:#2c3e5077;
    }

    .fav {
        background-color: #f1c40f;
        color:#2c3e50;
    }

</style>
